<template>
  <section>
    <Login_4_4 v-if="checkValidVersion('4.4.0')" :login="login" :from="from" :auth_uuid="auth_uuid"></Login_4_4>
    <Login v-if="!checkValidVersion('4.4.0')" :login="login" :from="from" :auth_uuid="auth_uuid"></Login>
  </section>
</template>
<script>
import Login from "@/components/Login.vue";
import Login_4_4 from "@/components_4_4/Login.vue";
export default {
  components: {
    Login,
    Login_4_4,
  },
  props: ["login", "from", "auth_uuid"],
  data() {},
  mounted: async function () {
    console.log("Mounted Login.vue");
  },
};
</script>
<style></style>
